<template>
  <van-pull-refresh v-model="isLoading" pulling-text="Tarik ke bawah untuk refresh..."
    loosing-text="Lepaskan untuk refresh..." success-text="Refresh Berhasil" loading-text=" " @refresh="onRefresh">
    <div class="content">
      <div class="top">
        <div class="title_img">
          <h4 class="name">
            <span>Pasar pinjaman</span>
            <span @click="visibleLogOut = true">Keluar</span>
          </h4>
          <div class="Semua_orabg_meminjam">
            <div>Semua orang meminjam</div>
            <span>Dapat mengajukan beberapa produk sekaligus</span>
          </div>
        </div>
        <div class="tongzhi">
          <van-notice-bar color="#AFDD23" background="#fff" :left-icon="trumpet" @click="visible = true">
            <span class="inform" v-for="(item, index) in form.msgList" :key="index">{{ item }}</span>
          </van-notice-bar>
        </div>
        <div class="top_bg">
          <div class="productBox">
            <img src="@/assets/img/product_icon.png" alt="" />
            <div>
              <div>UangMu</div>
              <span>{{
                form.loanStatus == 5
                  ? "Menunggu pembayaran"
                  : "Datan dan pinjam uang"
              }}</span>
            </div>
          </div>
          <div class="jine">
            <div class="title">
              {{
                form.loanStatus == 5 ? "Total Pembayaran" : "Pinjaman Maksimum"
              }}
            </div>
            <span>Rp {{ formatNumberWithCommas(form.loanMoney) }}</span>
          </div>
          <!-- 状态1到9 -->
          <div class="jeikaun_xinxi" v-if="form.loanStatus != 5">
            <div class="li_lv">
              <div>Bunga Pinjaman</div>
              <span>{{ form.interestRate }}</span>
            </div>
            <div class="tian_shu">
              <div>Tenor Pinjaman</div>
              <span>{{ form.loanTerm }} Hari</span>
            </div>
          </div>
          <!-- 状态5 -->
          <div class="jeikaun_xinxi" v-else>
            <div class="li_lv">
              <div>Tanggal pembayaran</div>
              <span>{{ form.interestRate }}</span>
            </div>
            <div class="tian_shu">
              <div>Jumlah Hari Keterlambatan</div>
              <span>{{ form.loanTerm }} Hari</span>
            </div>
          </div>

          <!-- 状态1-9按钮 -->
          <div v-if="form.loanStatus != 5" class="pinjam_uang" @click="goHome">
            Ajukan Sekarang
          </div>
          <!-- 状态5按钮 -->
          <div v-else class="pinjam_uang pinjam_uang5" @click="goHome">
            Pembayaran
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="productCard" v-for="(item, index) in form.marketList" :key="index" @click="goOther(item)">
          <div class="product">
            <img :src="item.product_logo" alt="" />
            <div class="productName">
              <div>{{ item.product_name }}</div>
              <span>{{ item.product_title }}</span>
            </div>
          </div>

          <div class="juta" v-for="(productItem, productIndex) in item.product_list" :key="productIndex">
            <div v-for="(value, key) in productItem" :key="key">
              <span>{{ key }}:</span>
              <span>{{
                typeof value === "number"
                  ? formatNumberWithCommas(value)
                  : value
              }}</span>
            </div>
          </div>
          <div class="Pinjaman_Hingga">
            <div class="left">
              <span> {{ item.PinjamanHinggaObj.value }}</span>
              <span> {{ item.PinjamanHinggaObj.name }}</span>
            </div>
            <div :class="item.product_click == 1 ? 'text_btn' : 'text_btn_disenable'
              " :style="{
                background: item.product_status == 5 ? '#fdc350' : '#afdd23',
              }">
              {{ item.product_button }}
            </div>
          </div>
          <van-notice-bar color="#AFDD23" background="#f4fef8" :left-icon="trumpet" @click="visible = true"
            v-if="item.msgList.length > 0">
            <span class="inform" v-for="(msgItem, msgIndex) in item.msgList" :key="msgIndex">{{ msgItem }}</span>
          </van-notice-bar>
        </div>
      </div>
      <div class="advertising" v-show="advertisingShow" @click="goAdvertising">
        <img src="@/assets/img/advertising_close.png" @click="advertisingShow = false" />
      </div>
      <van-dialog v-model="visible" :showConfirmButton="false">
        <div class="dialog">
          <p class="title">{{ form.msgList[0] }}</p>
          <p class="tip">
            {{ form.msgList[1] }}
          </p>
          <button type="button" class="btn" @click="visible = false">
            Setuju
          </button>
        </div>
      </van-dialog>
    </div>
    <van-dialog v-model="visibleLogOut" show-cancel-button cancel-button-text="Batal" confirm-button-text="Setuju"
      @cancel="visibleLogOut = false" @confirm="logOut">
      <h3 class="logout_text">yakin untuk keluar?</h3>
    </van-dialog>
    <van-dialog v-model="visibleHint" :showConfirmButton="false">
      <div class="hint_box">
        <img class="hint" src="@/assets/img/hint.png" alt="" />
        <img class="img_btn" src="@/assets/img/hint_btn.png" alt="" @click="visibleHint = false" />
      </div>
    </van-dialog>
  </van-pull-refresh>
</template>

<script>
import request from '@/utils/request'
import Vue from 'vue'
import { NoticeBar, Dialog, PullRefresh } from 'vant'
import dialogVisible from '@/mixins/dialogVisible'
import trumpet from '@/assets/img/trumpet.png'

import store from '@/store'
import router from '@/router'
import Cookies from 'js-cookie'
import trafficConfig from '@/mixins/trafficConfig'

Vue.use(NoticeBar)
Vue.use(PullRefresh)

export default {
  name: 'Home1',
  mixins: [dialogVisible, trafficConfig],
  components: {
    [Dialog.Component.name]: Dialog.Component
  },
  data () {
    return {
      trumpet: trumpet,
      isLoading: false,
      isRequest: false,
      advertisingShow: true,
      visibleLogOut: false,
      visibleHint: false,
      form: {
        marketList: [],
        msgList: [],
        product_list: []
      },
      PinjamanHinggaObj: {}
    }
  },
  created () {
    this.getState()
    const t = this
    // 添加 visibilitychange 事件监听器
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') {
        // 页面变为可见时执行的逻辑
        t.getState()
      }
    })
  },
  methods: {
    // 下拉刷新
    onRefresh () {
      this.getState()
    },
    // 获取状态
    getState () {
      request.post('marketHomepage').then(res => {
        res.marketList.forEach(item => {
          let obj = {}
          const length = item.product_list.length - 1
          obj = item.product_list[length]

          // 获取对象的所有键
          const keys = Object.keys(obj)
          item.PinjamanHinggaObj = {
            name: keys[keys.length - 1],
            value: obj[keys[keys.length - 1]]
          }
        })
        this.form = res
        this.form.marketList[0].PinjamanHinggaObj.value = 'Rp8.000.000'
        // this.form.marketList[0].product_name = this.productName
        this.form.marketList[0].product_name = 'STB'

        this.form.marketList[0].product_title = 'Pinjaman Online OJK'
        // this.form.marketList[0].product_logo = this.home1_yinliu_logo
        this.form.marketList[0].product_logo = require('@/assets/img/home1_yinliu_logo2.png')

        this.form.marketList[0].product_click = 1
        // this.form.marketList[0].appStore_url = this.downloadUrl
        this.form.marketList[0].appStore_url = 'https://apps.apple.com/id/app/stb-pinjamuang-santai/id6754629811?l=id'

        this.isLoading = false
      })
    },
    // 去首页
    goHome () {
      if (this.form.switch === 2) {
        this.visibleHint = true
        return
      }
      if (this.form.switch === 1) {
        this.$router.push({
          path: '/home'
        })
      }
    },
    // 跳转到其他项目
    goOther (item) {
      if (this.isRequest) {
        return
      }
      this.isRequest = true
      if (item.appStore_url) {
        this.isRequest = false
        window.location = item.appStore_url
        return
      }

      if (item.switch === 2) {
        this.visibleHint = true
        this.isRequest = false
        return
      }
      const phone = item.jump_url.match(/phone=([^&]*)/)[1]
      // 给定的完整 URL 字符串
      const urlString = item.jump_url
      // 使用字符串截取方法获取不带参数的跳转地址
      let redirectUrl = urlString.split('?')[0]
      // 判断最后一位是否是 '/'
      if (redirectUrl.endsWith('/')) {
        // 去掉最后一位
        redirectUrl = redirectUrl.slice(0, -1)
      }
      // 获取登录信息  UC
      request.post('https://maapi.nyxlyn.cc/queryUserInfo', { phone }).then(res => {
        window.location = `${redirectUrl}/transfer?data=${JSON.stringify(res)}&SSO=1`
        // window.location = `http://localhost:8080/transfer?data=${JSON.stringify(res)}&SSO=1`
      }).finally(() => {
        setTimeout(() => {
          this.isRequest = false
        }, 300)
      })
    },
    // 退出登录
    logOut () {
      store.commit('recordInfo', {
        type: 'userInfo',
        value: {}
      })
      window.localStorage.removeItem('userInfo')
      Cookies.remove('userInfo')
      router.push({
        path: '/login'
      })
    },
    // BRD
    goAdvertising () {
      window.location = this.brdDownloadUrl
    }
  }
}
</script>
<style scoped lang="less">
.content {
  background: #f7f8ff;
  min-height: 100vh;

  .advertising {
    height: 90px;
    width: 100%;
    position: fixed;
    bottom: 0;
    background: url("~@/assets/img/advertising_bg.png") no-repeat;
    background-size: 100% 100%;

    img {
      position: absolute;
      width: 28px;
    }
  }
}

.top {
  background: url("~@/assets/img/home1_bg.png") no-repeat;
  background-size: 100% 100%;

  .title_img {
    padding-left: 28px;
    margin-bottom: 30px;

    .name {
      position: relative;
      margin-bottom: 10px;
      padding-right: 28px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 0;
      padding-top: 10px;

      span {
        font-weight: bold;
        font-size: 48px;
        color: #afdd23;
      }

      span:nth-child(2) {
        // position: absolute;
        // top: 10px;
        // right: 28px;
        border-bottom: 1px solid #afdd23;
        font-size: 32px;
      }
    }

    .Semua_orabg_meminjam {
      position: relative;
      font-size: 0;

      div {
        font-weight: 600;
        font-size: 28px;
        color: #333333;
        margin-bottom: 1px;
      }

      span {
        font-weight: 400;
        font-size: 28px;
        color: #555;
      }

      img {
        position: absolute;
        right: 60px;
        bottom: -16px;
        width: 142px;
        z-index: 9;
      }
    }
  }

  .tongzhi {
    margin-bottom: 40px;

    /deep/ .van-icon__image {
      width: 30px;
      height: 29px;
      margin-right: 10px;
    }

    /deep/ .van-notice-bar {
      border-radius: 72px;
      margin: 0 auto;
      height: 72px;
      width: 598px;
      box-shadow: 0px 0px 10px 0px rgba(76, 207, 168, 0.26);
    }
  }

  .top_bg {
    position: relative;
    background: url("~@/assets/img/top_bg.png") no-repeat;
    background-size: 100% 100%;
    border-radius: 28px;
    margin: 0 32px;
    padding: 52px;

    .productBox {
      position: relative;
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      padding-top: 50px;

      img {
        width: 111px;
        margin-bottom: 12px;
        margin-right: 15px;
      }

      div {
        font-size: 24px;

        div {
          font-weight: bold;
          font-size: 32px;
          color: #333333;
          margin-bottom: 8px;
        }

        span {
          font-weight: 500;
          font-size: 24px;
          color: #ff7d17;
        }
      }
    }

    .jine {
      font-size: 0;
      padding: 10px 0;
      margin-bottom: 35px;

      span {
        font-weight: bold;
        font-size: 60px;
        color: #afdd23;
      }

      .title {
        font-weight: 500;
        font-size: 32px;
        color: #aaaaaa;
        margin-bottom: 8px;
      }
    }

    .jeikaun_xinxi {
      position: relative;
      display: flex;
      gap: 30px;
      margin-bottom: 40px;
      font-size: 26px;

      .li_lv,
      .tian_shu {
        flex: 1;

        div {
          font-weight: 500;
          font-size: 28px;
          color: #aaaaaa;
          margin-bottom: 10px;
          width: 250px;
        }

        span {
          font-weight: bold;
          font-size: 44px;
          color: #afdd23;
        }
      }
    }

    .pinjam_uang {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 31px;
      color: #ffffff;
      margin: 0 auto;
      width: 582px;
      height: 80px;
      background: #afdd23;
      border-radius: 16px 16px 16px 16px;
    }

    .pinjam_uang5 {
      background: #fdc350;
    }
  }
}

.bottom {
  padding: 78px 32px;
  padding-top: 30px;

  .productCard {
    margin-bottom: 24px;
    width: 634px;
    background: #ffffff;
    border-radius: 28px;
    border: 1px solid #e3e3e3;
    padding: 20px;

    /deep/ .van-icon__image {
      width: 27px;
      height: 26px;
      margin-right: 10px;
    }

    /deep/ .van-notice-bar {
      height: 69px;
      border: 1px solid #f2ecec;
      margin-bottom: 23px;
      border: none;
    }

    .product {
      display: flex;
      align-items: center;

      img {
        width: 95px;
        height: 95px;
        margin-right: 16px;
      }

      .productName {
        font-size: 22px;

        div {
          font-weight: 600;
          font-size: 30px;
          color: #333333;
          margin-bottom: 8px;
        }

        span {
          font-weight: 400;
          font-size: 22px;
          color: #666666;
        }
      }
    }
  }

  .juta {
    div {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      height: 45px;
      padding: 0 20px;
      font-weight: 400;
      font-size: 26px;
      color: #666666;
    }

    div:nth-child(1) {
      margin-top: 21px;
    }

    div:nth-last-child(2) {
      margin-bottom: 21px;
    }

    // 选中最后一个元素
    div:last-child {
      display: none;
    }
  }

  .Pinjaman_Hingga {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    padding: 0 20px;

    .left {
      span {
        display: block;
        font-weight: bold;
        font-size: 32px;
        color: #afdd23;
      }

      span:nth-child(2) {
        display: block;
        font-weight: 500;
        font-size: 24px;
        color: #333333;
        margin-top: 8px;
      }
    }

    .text_btn {
      margin-left: auto;
      width: 311px;
      height: 74px;
      background: #cdcdcd;
      border-radius: 16px 16px 16px 16px;
      font-weight: 600;
      font-size: 24px;
      line-height: 74px;
      text-align: center;
      color: #fff;
    }

    .text_btn_disenable {
      .text_btn;
      background: #cdcdcd !important;
    }
  }

  .describe {
    padding: 20px;
    padding-top: 10px;
    background: #f8f8f8;
    font-weight: 400;
    font-size: 26px;
    color: #999999;
    line-height: 37px;
    margin-bottom: 30px;
  }
}

.van-dialog {
  background: #fff;
}

.dialog {
  padding: 40px 30px;

  .title {
    font-size: 50px;
    font-weight: 600;
    margin-bottom: 20px;
  }

  .tip {
    font-size: 35px;
    font-weight: 500;
    margin-bottom: 70px;
  }

  .btn {
    width: 100%;
    height: 100px;
    border-radius: 15px;
    font-size: 40px;
    font-weight: 600;
    color: #fff;
    background: #3a3a3a;
  }
}

.logout_text {
  color: #000;
  font-size: 46px;
  margin: 60px 0px;
  text-align: center;
}

.hint_box {
  position: relative;

  .hint {
    width: 100%;
  }

  .img_btn {
    position: absolute;
    bottom: 50px;
    left: 50%;
    transform: translateX(-50%);
    width: 500px;
  }
}
</style>
